export default "__VITE_ASSET__508MR4rU__"